import { bffApi } from "../../autogen/bff-api";

export const tagsInvalidatedByScoreSave = (_result: unknown, error: unknown) =>
  error ? (["SourcingEvent", "BidV2"] as const) : (["SourcingEvent"] as const);

bffApi.enhanceEndpoints({
  endpoints: {
    upsertCriterionScore: {
      invalidatesTags: (result, error) => [...tagsInvalidatedByScoreSave(result, error)],
    },
    upsertPriceOverride: {
      invalidatesTags: (result, error) => [...tagsInvalidatedByScoreSave(result, error)],
    },
  },
});
